import * as React from 'react';
import { LocalDatasheetTabDto } from '../../types/tab-dto';
import { DatasheetLocalGetDto } from '../../types/datasheet';
import { DatasheetElement, DatasheetElementId } from '@modules/datasheets/types/datasheet-element';

type Props = {
  copiedDatasheetElementsFromTab: Record<DatasheetElementId, DatasheetElement>;
  currentTabId?: LocalDatasheetTabDto['id'];
  datasheet: DatasheetLocalGetDto;
  onDatasheetChange: (datasheet: DatasheetLocalGetDto) => void;
};

export const useTabsController = (props: Props) => {
  const { onDatasheetChange, datasheet, currentTabId, copiedDatasheetElementsFromTab } = props;

  const handleTabOrderChange = React.useCallback((tabs: DatasheetLocalGetDto['tabs']) => {
    onDatasheetChange({
      ...datasheet,
      tabs 
    });
  }, [datasheet, onDatasheetChange]);

  const handleTabRename = React.useCallback((tabName: string) => {
    onDatasheetChange({
      ...datasheet,
      tabs: datasheet.tabs.map(tab => tab.id === currentTabId ? { ...tab, name: tabName } : tab)
    });
  }, [onDatasheetChange, datasheet, currentTabId]);

  const pastingOfTabElementsAllowed = React.useMemo(() => {
    return Object.keys(copiedDatasheetElementsFromTab).length > 0;
  }, [copiedDatasheetElementsFromTab]);

  return {
    pastingOfTabElementsAllowed,
    handleTabRename,
    handleTabOrderChange
  };
};